<app-mu-section-title
  title="context.massive.cfdi.breadcrumb.title"
  subTitle="context.massive.cfdi.breadcrumb.subtitle"
></app-mu-section-title>
<app-file-upload-form #fileUploadform [formData]="formData" [flagList]="flagList" [uploadFileFlag]="massiveCfdiFlags.UPLOAD_FILE">
</app-file-upload-form>

<app-mu-modal-dialog-layout
    [hideLine]="true"
    [showFlag]="massiveCfdiFlags.SHOW_UPLOAD_FILE_MODAL"
    [flagList]="flagList"
    [showCloseIcon]="true"
    [showCloseIcon]="false"
    >
    <div modalDialogContent>
        <i id="spinner-icon-lg" class="fas fa-spinner fa-pulse mu-large-icon" aria-hidden="true"></i>
        <p>
            {{'context.massive.cfdi.fileModal.loading' | translate}}
        </p>
    </div>
</app-mu-modal-dialog-layout>

<app-mu-modal-dialog-layout
  [icon]="'mu-icon-check'"
  [subTitle]="downloadFileModalSubTitle"
  [hideLine]="true"
  [showFlag]="massiveCfdiFlags.SHOW_DOWNLOAD_FILE_MODAL"
  [flagList]="flagList"
  [showCloseIcon]="true"
  (eventCloseDialogModal)="closeErrorModalDialog(fileUploadform)"
>
  <div modalDialogButton class="p-col-12 p-md-6 mu-modal-button mu-modal-button-left" *ngIf="!cfdiDownloaded">
    <app-mu-button
      [label]="'context.massive.cfdi.fileModal.cancelButton' | translate"
      class="mu-button mu-button-outline"
      [flagList]="flagList"
      [flag]="massiveCfdiFlags.CANCEL_DOWNLOAD_CFDI"
    ></app-mu-button>
  </div>
  <div modalDialogButton class="p-col-12 p-md-6 mu-modal-button mu-modal-button-right" *ngIf="!cfdiDownloaded">
    <app-mu-button
      [label]="'context.massive.cfdi.fileModal.confirmButton' | translate"
      [flagList]="flagList"
      [flag]="massiveCfdiFlags.DOWNLOAD_CFDI"
    ></app-mu-button>
  </div>
</app-mu-modal-dialog-layout>

<app-mu-modal-dialog-layout 
    id="modalDialogLayoutError"
    [hideLine]="true"
    [flagList]="flagList"
    [showCloseIcon]="true"
    [showFlag]="massiveCfdiFlags.SHOW_CFDI_ERROR_MODAL"
    (eventCloseDialogModal)="closeErrorModalDialog(fileUploadform)">
    >
    <div modalDialogContent>
        <i id="times-circle-icon-lg" class="fas fa-times-circle mu-red-icon" aria-hidden="true"></i>
        <div>
            <h3>
                {{'context.massive.cfdi.fileModal.error' | translate}}
            </h3>
            <br>
            <h3>
                {{errorMessage}}
            </h3>
            <br>
            <h3>
                {{'context.massive.cfdi.fileModal.tryAgain' | translate}}
            </h3>
        </div>
    </div>
</app-mu-modal-dialog-layout>
